import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class ArbiterApi extends Api{

    static getReasonCodes(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_REASON_CODES}`;
        options.params = params;
        return request.get(options);
    }
    static getReasonCodesByCategory(category){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_REASON_CODES_BY_CATEGORY}/${category}`;
        options.params = {};
        return request.get(options);
    }

    static getTransactionGroups(){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_GROUPS}`;
        options.params = {};
        return request.get(options);
    }

    static getDisputeRegions(){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_REGIONS}`;
        options.params = {};
        return request.get(options);
    }
}

export default ArbiterApi;


// WEBPACK FOOTER //
// ./src/api/ArbiterApi.js